var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMockAntenna(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.123 0.587402C14.5707 0.587402 14.123 1.03512 14.123 1.5874V10.049C14.123 10.6013 14.5707 11.049 15.123 11.049H16.2615C16.8138 11.049 17.2615 10.6013 17.2615 10.049V1.5874C17.2615 1.03512 16.8138 0.587402 16.2615 0.587402H15.123ZM9.41559 3.67967C9.41559 3.12739 9.8633 2.67967 10.4156 2.67967H11.5541C12.1064 2.67967 12.5541 3.12739 12.5541 3.67967V10.049C12.5541 10.6012 12.1064 11.049 11.5541 11.049H10.4156C9.8633 11.049 9.41559 10.6012 9.41559 10.049V3.67967ZM5.70767 4.77206C5.15539 4.77206 4.70767 5.21978 4.70767 5.77206V10.049C4.70767 10.6013 5.15539 11.049 5.70767 11.049H6.84615C7.39844 11.049 7.84615 10.6013 7.84615 10.049V5.77206C7.84615 5.21978 7.39844 4.77206 6.84615 4.77206H5.70767ZM1.04616 11.049C0.468382 11.049 0 10.5806 0 10.0028V7.38744C0 6.80966 0.468382 6.34128 1.04616 6.34128H2.09232C2.6701 6.34128 3.13848 6.80966 3.13848 7.38744V10.0028C3.13848 10.5806 2.6701 11.049 2.09232 11.049H1.04616Z",
    fill: "#444444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMockAntenna);
export default __webpack_public_path__ + "static/media/mock_antenna.81c01909ab00c39b09b231d13d98b34b.svg";
export { ForwardRef as ReactComponent };